// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M4 6L8 10\" stroke=\"#060606\" stroke-width=\"3\" stroke-linecap=\"round\"/> <path d=\"M12 6L8 10\" stroke=\"#060606\" stroke-width=\"3\" stroke-linecap=\"round\"/> </svg> ";
// Exports
module.exports = code;